import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

// Páginas base
import Home from '../pages/Home/Home'
import Login from '../pages/Login/Login'
import ResetPassword from '../pages/ResetPassword/ResetPassword'
import Perfil from '../pages/Perfil/Perfil'
import ValidateMail from '../pages/ChangePassword/ValidateMail'
import ChangePassword from '../pages/ChangePassword/ChangePassword'

// Layout
import Layout from '../components/Layout/Layout'

// Guards
import ProtectedRoutes from '../Services/ProtectedRoutes'
import PrivateRoutesAdmin from '../Services/PrivateRoutesAdmin'
import PrivateRoutesBank from '../Services/PrivateRoutesBank'
import PrivateRoutesNormas from '../Services/PrivateRoutesNormas'

// Context
import { PlanesProvider } from '../context/PlanesContext'
import { OkrProvider } from '../context/OkrContext'
import { AdminProvider } from '../context/AdminContext'
import { AreaProvider } from '../context/AreaContext'
import { NormasProvider } from '../context/NormasContext'

// Componentes de Admin
import HomeAdmin from '../pages/Admin/HomeAdmin'
import Areas from '../pages/Home/Areas'
import Flowchart from "../pages/Admin/Flowchart"
import FlowchartEmpresas from '../pages/Admin/FlowchartEmpresas'
import FlowchartEmpleados from '../pages/Admin/FlowchartEmpleados'

// Componentes de Dashboard
import PowerBI from '../components/PowerBI'

// Componentes de Planes de Acción
import HomePlanesAccion from '../pages/PlanesAccion/HomePlanesAccion'
import Gantt from '../pages/PlanesAccion/Gantt'
import Proyectos from '../pages/PlanesAccion/Proyectos'
import AreasPA from '../pages/PlanesAccion/AreasPA'

// Componentes de Planes de Auditoría
import HomeAuditoria from '../pages/PlanesAuditoria/HomeAuditoria'
import GanttAudit from '../pages/PlanesAuditoria/GanttAudit'
import Ciclos from '../pages/PlanesAuditoria/Ciclos'

// Componentes de DatIN
import HomeDatIN from '../pages/DatIN/HomeDatIN'
import AreasDatIN from '../pages/DatIN/AreasDatIN'
import DatIN from '../pages/DatIN/DatIN'

// Componentes de OKR
import HomeOkr from '../pages/Okr/HomeOkr'
import AreasOkr from '../pages/Okr/AreasOkr'
import ListaOkr from '../pages/Okr/ListaOkr'
import DetalleOkr from '../pages/Okr/DetalleOkr'
import DetalleOkrPersonal from '../pages/Okr/DetalleOkrPersonal'
import DetalleKeyResult from '../pages/Okr/DetalleKeyResult'

// Componentes de Normas
import HomeNormas from '../pages/Normas/HomeNormas'
import ListaProyectos from '../pages/Normas/ListaProyectos'
import DetalleProyecto from '../pages/Normas/DetalleProyecto'
import EditarNorma from '../pages/Normas/EditarNorma'

// Redirección dinámica
import HomeRedirect from '../Services/HomeRedirect'

// 404 NotFound
import NotFound from '../pages/NotFound/NotFound'

function MyRoutes() {
  return (
    <BrowserRouter>
      <NormasProvider>
        <PlanesProvider>
          <OkrProvider>
            <AdminProvider>
              <AreaProvider>
                <Routes>
                    <Route path="/" element={<Login />}/>
                    <Route path="reset-password" element={<ResetPassword />} />
                    <Route path='validate-mail' element={<ValidateMail />} />
                    <Route path="change-password" element={<ChangePassword />} />
                    <Route path='/inicio' element={<HomeRedirect />} />
                    {/* protected routes */}
                    <Route element={<ProtectedRoutes />}>
                      <Route element={<PrivateRoutesNormas />}>
                        <Route element={<Layout />}>
                            <Route path="home">
                              <Route index element={<Home />} />
                              {/* USUARIO 1 y 2 */}
                              <Route path='consultora/:idConsult/empresa/:id'>
                                <Route index element={<Areas />}/>
                                <Route path="powerbi/:idArea" element={<PowerBI />} />
                              </Route>
                              {/* USUARIO 3 y demás */}
                              <Route path='powerbi/:idArea'>
                                <Route index element={<PowerBI />} />
                              </Route>
                            </Route>
                            <Route path="/perfil" element={<Perfil />} />
                            {/* VISTA ADMIN PARA CREACION DE USUARIO */}
                            <Route path="/admin" element={<PrivateRoutesAdmin />}>
                              <Route index element={<HomeAdmin />}/>
                              {/* USUARIO 1 */}
                              <Route path="consultoras/flowchart" element={<Flowchart />} />
                              {/* USUARIO 2 */}
                              <Route path="empresas/flowchart" element={<FlowchartEmpresas />} />
                              {/* USUARIO 3 */}
                              <Route path="empleados/flowchart" element={<FlowchartEmpleados />} />
                            </Route>
                            <Route element={<PrivateRoutesBank />}>
                              {/* PLANES DE ACCION PLANES DE ACCION */}
                              <Route path="planes-de-accion">
                                <Route index element={<HomePlanesAccion />} />
                                {/* USUARIO 1 y 2 */}
                                <Route path='consultora/:idConsult/empresa/:id'>
                                  <Route index element={<AreasPA />}/>
                                  <Route path="area/:idArea">
                                    <Route index element={<Gantt />} />
                                    <Route path=':yearDefault/proyectos/:idProyec' element={<Proyectos />} />
                                    <Route path=':yearDefault/proyectos' element={<Proyectos />} />
                                  </Route>
                                </Route>
                                {/* USUARIO 3 */}
                                <Route path='area/:idArea'>
                                  <Route index element={<Gantt />} />
                                  <Route path=':yearDefault/proyectos/:idProyec' element={<Proyectos />} />
                                  <Route path=':yearDefault/proyectos' element={<Proyectos />} />
                                </Route>
                                {/* USUARIO 4 y 5 */}
                                <Route path=':yearDefault/proyectos/:idProyec'>
                                  <Route index element={<Proyectos />} />
                                </Route>
                                <Route path=':yearDefault/proyectos'>
                                  <Route index element={<Proyectos />} />
                                </Route>
                              </Route>
                              {/* PLANES DE AUDITORIA PLANES DE AUDITORIA */}
                              <Route path="plan-de-auditoria">
                                <Route index element={<HomeAuditoria />} />
                                {/* USUARIO 1 y 2 */}
                                <Route path='consultora/:idConsult/empresa/:id'>
                                    <Route index element={<GanttAudit />} />
                                    <Route path=':yearDefault/ciclos/:idCiclo' element={<Ciclos />} />
                                    <Route path=':yearDefault/ciclos' element={<Ciclos />} />
                                </Route>
                                {/* USUARIO 3, 4 y 5 */}
                                <Route index element={<GanttAudit />} />
                                <Route path=':yearDefault/ciclos/:idCiclo' element={<Ciclos />} />
                                <Route path=':yearDefault/ciclos' element={<Ciclos />} />
                              </Route>
                            </Route>
                            {/* OKR OKR OKR */}
                            <Route path="/okr">
                              <Route index element={<HomeOkr />} />
                              {/* OKR USUARIO 1 */}
                              <Route path='consultora/:idConsult/empresa/:id'>
                                <Route index element={<AreasOkr />}/>
                                <Route path='empresariales/:idOkr'>
                                  <Route index element={<DetalleOkr />}/>
                                  <Route path='keyresult/:idKeyResult'>
                                    <Route index element={<DetalleKeyResult />}/>
                                  </Route>
                                </Route>
                                <Route path="area/:idArea">
                                  <Route index element={<ListaOkr />} />
                                  <Route path="okr/:idOkr">
                                    <Route index element={<DetalleOkr />}/>
                                    <Route path='keyresult/:idKeyResult'>
                                      <Route index element={<DetalleKeyResult />}/>
                                    </Route>
                                  </Route>
                                </Route>
                              </Route>
                              {/* OKR USUARIO 2 */}
                              <Route path='empresa/:id'>
                                <Route index element={<AreasOkr />}/>
                                <Route path='empresariales/:idOkr'>
                                  <Route index element={<DetalleOkr />}/>
                                  <Route path='keyresult/:idKeyResult'>
                                    <Route index element={<DetalleKeyResult />}/>
                                  </Route>
                                </Route>
                                <Route path="area/:idArea">
                                  <Route index element={<ListaOkr />} />
                                  <Route path="okr/:idOkr">
                                    <Route index element={<DetalleOkr />}/>
                                    <Route path='keyresult/:idKeyResult'>
                                      <Route index element={<DetalleKeyResult />}/>
                                    </Route>
                                  </Route>
                                </Route>
                              </Route>
                              {/* OKR USUARIO 3 EN ADELANTE */}
                              {/* OKR PERSONALES */}
                              <Route path='personales/:idOkr'>
                                <Route index element={<DetalleOkrPersonal />}/>
                                <Route path='keyresult/:idKeyResult'>
                                  <Route index element={<DetalleKeyResult />}/>
                                </Route>
                              </Route>
                              {/* OKR POR EMPRESA */}
                              <Route path='empresariales/:idOkr'>
                                <Route index element={<DetalleOkr />} />
                                <Route path='keyresult/:idKeyResult'>
                                  <Route index element={<DetalleKeyResult />}/>
                                </Route>
                              </Route>
                              {/* OKR POR AREA */}
                              <Route path="area/:idArea">
                                <Route index element={<ListaOkr />} />
                                <Route path="okr/:idOkr">
                                  <Route index element={<DetalleOkr />}/>
                                  <Route path='keyresult/:idKeyResult'>
                                    <Route index element={<DetalleKeyResult />}/>
                                  </Route>
                                </Route>
                              </Route>
                            </Route>
                            <Route path="/dat-in">
                              <Route index element={<HomeDatIN />} />
                              {/* USUARIO 1 y 2 */}
                              <Route path='consultora/:idConsult/empresa/:id'>
                                <Route index element={<AreasDatIN />}/>
                                <Route path="area/:idArea">
                                  <Route index element={<DatIN />} />
                                </Route>
                              </Route>
                              {/* USUARIO 3 */}
                              <Route path='area/:idArea'>
                                <Route index element={<DatIN />} />
                              </Route>
                            </Route>
                            <Route path="/normas">
                              <Route index element={<HomeNormas />} />
                              <Route path="editar-normas">
                                <Route index element={<EditarNorma />} />
                              </Route>
                              {/* USUARIO 1 */}
                              <Route path='consultora/:idConsult/empresa/:id'>
                                  <Route index element={<ListaProyectos />} />
                                  <Route path="proyecto/:idProyecto">
                                    <Route index element={<DetalleProyecto />} />
                                  </Route>
                              </Route>
                              {/* USUARIO 2 */}
                              <Route path='empresa/:id'>
                                <Route index element={<ListaProyectos />} />
                                  <Route path="proyecto/:idProyecto">
                                  <Route index element={<DetalleProyecto />} />
                                </Route>
                              </Route>
                              {/* USUARIOS 3-7 */}
                              <Route path='proyecto/:idProyecto'>
                                <Route index element={<DetalleProyecto />} />
                              </Route>
                            </Route>
                            <Route path="*" element={<NotFound />} />
                        </Route>
                      </Route>
                    </Route>
                </Routes>
              </AreaProvider>
            </AdminProvider>
          </OkrProvider>
        </PlanesProvider>
      </NormasProvider>
    </BrowserRouter>
  )
}

export default MyRoutes